import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function ConfirmingStep() {
  const { t } = useTranslation('signature');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 4,
      }}
    >
      <CircularProgress size={48} />
      <Typography sx={{ mt: 2 }}>{t('confirmingStep')}</Typography>
    </Box>
  );
}
